export default __webpack_public_path__ + "static/media/640.a848dbe3.gif";